import types from './types';

const setIncident = (incident) => ({
  type: types.SET_INCIDENT,
  payload: {
    incident
  }
});

const setNewIncidentProtectingUnit = (protectingUnit) => ({
  type: types.SET_NEWINCIDENT_PROTECTING_UNIT,
  payload: {
    protectingUnit
  }
});
const clearIncident = () => ({
  type: types.CLEAR_INCIDENT,
  payload: {}
});

const setRelationships = (relationships) => ({
  type: types.SET_RELATIONSHIPS,
  payload: {
    relationships
  }
});

const clearRelationships = () => ({
  type: types.CLEAR_RELATIONSHIPS,
  payload: {}
});

const setADSStatus = (adsStatus) => ({
  type: types.SET_ADS_STATUS,
  payload: {
    adsStatus
  }
});

const clearADSStatus = () => ({
  type: types.CLEAR_ADS_STATUS,
  payload: {}
});


const setPerimeter = (perimeter) => ({
  type: types.SET_PERIMETER,
  payload: {
    perimeter
  }
});

const setPerimeterFields = (perimeterFields) => ({
  type: types.SET_PERIMETER_FIELDS,
  payload: {
    perimeterFields
  }
});

const setPreIncidentExtent = (preIncidentExtent) => ({
  type: types.SET_PRE_INCIDENT_EXTENT,
  payload: {
    preIncidentExtent
  }
});

const clearPerimeter = () => ({
  type: types.CLEAR_PERIMETER,
  payload: {}
});

const clearPerimeterFields = () => ({
  type: types.CLEAR_PERIMETER_FIELDS,
  payload: {}
});



/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setIncident,
  clearIncident,
  setPerimeter,
  setPerimeterFields,
  clearPerimeter,
  clearPerimeterFields,
  setRelationships,
  clearRelationships,
  setADSStatus,
  clearADSStatus,
  setNewIncidentProtectingUnit,
  setPreIncidentExtent
};
